<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Work Group Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${work_group.name}`">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit work group'">
      <template #gated-content>
        <work-group-form :work_group="work_group" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import WorkGroupForm from "@/components/lab/workgroup/WorkGroupForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { workGroupNotifications } from "@/shared/notifications";

const WorkGroupRepository = LabRepositoryFactory.get("workGroup");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "WorkGroupEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkGroupForm,
  },
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      work_group_id: this.$route.params.work_group_id || null,
      work_group: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/workgroups",
            title: "Work Group list",
          },
          {
            icon: "fa-eye",
            linkto: `/workgroups/${this.work_group_id}`,
            title: "View Work Group",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(payload) {
      try {
        await WorkGroupRepository.update(this.work_group_id, payload);

        this.editSuccess();
        this.$router.push(`/workgroups/${this.work_group_id}`);
      } catch ({ response }) {
        const { message, error } = response.data;
        this.editFail({ message: message || error });
      }
    },
  },
  async created() {
    this.loading = true;

    this.work_group = await getModel({
      model_type: "work_group",
      id: this.work_group_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: workGroupNotifications,
};
</script>
